import Button from '@atlaskit/button';
import { PopupSelect } from '@atlaskit/select';
import React, { FC, useEffect, useMemo } from 'react';


import { stringifyZone } from '../../../../../utils';
import timezone from '../../../../../utils/timezone';
import { Icon, IconArrowDownNative } from '../../../base/icons';
import moment from 'moment';

interface SelectPopupTimeZoneProps {
    onChangeTimeZone?: () => void,
    timeZone?: string
}
const SelectPopupTimeZone: FC<SelectPopupTimeZoneProps> = ({ onChangeTimeZone = () => {}, timeZone }) => {
    const optionsTimezone = useMemo(() => timezone.map(item => {
        return {
            label: stringifyZone(item, 'GMT'),
            value: item.name
        };
    }), []);
    const defaultTimezone = optionsTimezone.find(i => i.value.includes(moment.tz.guess()));
    const defaults = {
        options: optionsTimezone.filter(item => item.label !== timeZone && item),
        placeholder: timeZone ?? 'Select a time zone',
        'aria-label': 'Select a time zone',
        onChange: value => {
            onChangeTimeZone(value);
        }
    };
    const styled = {
        control: (base, state) => {
            return {
                ...base,
                backgroundColor: '#F8F8F8',
                border: 'none',
                borderColor: state.isFocused ? '#F8F8F8' : '#000',
                borderRadius: 26,
                outline: 'none'
            };
        },
        indicatorsContainer: base => {
            return {
                ...base,
                display: 'none'
            };
        },
        options: base => {
            return {
                ...base,
                padding: '10px 0px'
            };
        }
    };

    useEffect(() => {
        if (!timeZone) {
            onChangeTimeZone(defaultTimezone);
        }
    }, []);

    return (
        <PopupSelect
            { ...defaults }
            classNamePrefix = 'timezone-select'
            styles = { styled }
            target = { ({ isOpen, ...triggerProps }) => (
                <Button
                    className = 'button-popup-timezone'
                    iconAfter = { <div className = 'background-check'><Icon
                        src = { IconArrowDownNative }
                        size = { 15 }
                        style = {{ fill: '#000' }} /></div> }
                    { ...triggerProps }
                    isSelected = { isOpen }>
                    <span className = 'text-timezone'>{timeZone ?? 'Time Zone'}</span>
                </Button>
            ) } />
    );
};

export default SelectPopupTimeZone;
